import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MdArrowBack, MdChevronLeft } from 'react-icons/md';
import { useRestaurantNav } from '../../hooks/useRestaurantNav';

interface PageHeaderProps {
  title: string;
  userName?: string;
  showBackButton?: boolean;
  onBackClick?: () => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  userName,
  showBackButton = true,
  onBackClick
}) => {
  const { navigate } = useRestaurantNav();

  const handleBackClick = () => {
    if (onBackClick) {
      onBackClick();
    } else {
      navigate(-1); // Go back to previous page
    }
  };

  return (
    <div 
      className="w-full px-6 py-4 mb-6 flex items-center justify-between relative overflow-hidden"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 14px 0px',
        background: 'linear-gradient(90deg, rgba(33, 33, 33, 0.92), rgba(55, 55, 55, 0.92))',
        border: '1px solid rgba(224, 224, 224, 0.13)',
        borderRadius: '12px'
      }}
    >
      {/* Dotted Pattern Overlay */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-20"
        style={{
          backgroundImage: 'radial-gradient(circle, rgba(224, 224, 224) 1px, transparent 1px)',
          backgroundSize: '20px 20px'
        }}
      />
      {/* Left: Logo and Welcome Text */}
      <div className="flex items-center gap-4">
        
        <div className="flex items-center gap-2">
          {showBackButton && (
            <button
              onClick={handleBackClick}
              className="text-gray-300 cursor-pointer bg-[#000000] rounded-full hover:text-brand-primary transition-colors p-[2px]"
              aria-label="Go back"
            >
              <MdChevronLeft size={24} />
            </button>
          )}
          <h1 className="text-xl font-normal text-white">
            {title}
            {userName && (
              <span className="text-brand-primary"> {userName}!</span>
            )}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
